import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TabsModule } from 'primeng/tabs';
import { MisureTelaioComponent } from './misure-telaio/misure-telaio.component';

@Component({
    selector: 'app-misure-intersezione',
    templateUrl: './misure-intersezione.component.html',
    imports: [CommonModule, ReactiveFormsModule, TabsModule, MisureTelaioComponent],
    standalone: true
})
export class MisureIntersezioneComponent {
    @Input() form!: FormGroup;
    @Input() normativa: any;
    @Input() selectedTab: string | number = 'telaio1';
    @Input() formReady: boolean = false;
    @Input() deviatoioId!: any;
    @Input() mode!: string;

    @Output() selectedTabChange = new EventEmitter<string | number>();

    onTabChange(tab: string | number) {
        this.selectedTab = tab;
        this.selectedTabChange.emit(tab);
    }

    getNormativaByTab(tab: string): any | null {
        return this.normativa?.find((n: any) => n.tab === tab) ?? null;
    }
}
